import { createContext } from 'react';

// ให้ ProjectSingleDashboard.js (ลูกหลานของ DraggablePaper ใน ProjectList.js) เรียกรีเซ็ต
// ตำแหน่ง popup ที่ลากไว้กลับที่เดิมได้ — ค่า default เป็น null (เช่น ตอนอยู่ใน New Window ที่ไม่มี
// DraggablePaper ครอบ ปุ่ม recenter จะไม่โผล่ เพราะไม่มีอะไรให้ reset)
const PopupDragContext = createContext(null);

export default PopupDragContext;
